((function () {


    window.adev_auto_upsell_config = window.adev_auto_upsell_config || {};
    window.adev_auto_upsell_config.timeout = null;
    window.adev_auto_upsell_config.finished = true;

    document.addEventListener('adev:auto_upsell:init', function () {
        window.adev_auto_upsell_config.finished = false;
        fetch("/cart.js")
            .then(function (response) {
                return response.json();
            })
            .then(function (cartData) {
                window.adev_cart = cartData;

                if (window.adev_auto_upsell.length === 0 || cartData.items.length === 0) {
                    window.adev_auto_upsell_config.finished = true;
                    return;
                }

                var itemsToAdd = [];
                var itemsToRemove = [];
                var upsellRules = window.adev_auto_upsell;
                var cartItems = cartData.items;

                const filteredUpsellRules = upsellRules.filter(function (rule) {
                    const totalQuantity = cartItems.reduce(function (total, item) {
                        return item.product_id === rule.product_id ? total + item.quantity : total;
                    }, 0);

                    return rule.product_id === "any" || totalQuantity >= rule.quantity;
                });

                filteredUpsellRules.forEach(function (rule) {
                    let except = rule.except || [];
                    except = except.map(function (id) {
                        return parseInt(id);
                    });

                    if (rule.product_id === "any") {
                        var totalQuantity = cartItems.reduce(function (total, item) {
                            if (except.includes(item.product_id)) {
                                return total;
                            }

                            return total + item.quantity;
                        }, 0);

                        var existingUpsellItem = cartItems.find(function (item) {
                            return item.variant_id === rule.variant_id && item.properties && item.properties.hasOwnProperty("__adev_upsell_gift");
                        });

                        if (existingUpsellItem) totalQuantity -= 1;

                        if (totalQuantity >= rule.quantity) {
                            if (!existingUpsellItem) {
                                itemsToAdd.push({
                                    id: rule.variant_id,
                                    quantity: 1
                                });
                            }
                        } else if (existingUpsellItem) {
                            itemsToRemove.push({
                                id: rule.variant_id,
                                quantity: 1
                            });
                        }
                    } else {
                        var productQuantity = cartItems.reduce(function (total, item) {
                            return item.product_id === rule.product_id ? total + item.quantity : total;
                        }, 0);

                        var existingUpsellItem = cartItems.find(function (item) {
                            return item.variant_id === rule.variant_id && item.properties && item.properties.hasOwnProperty("__adev_upsell_gift");
                        });

                        if (productQuantity >= rule.quantity) {
                            if (!existingUpsellItem) {
                                itemsToAdd.push({
                                    id: rule.variant_id,
                                    quantity: 1
                                });
                            }
                        } else if (existingUpsellItem) {
                            itemsToRemove.push({
                                id: rule.variant_id,
                                quantity: 1
                            });
                        }
                    }
                });

                // Remove items if necessary
                if (itemsToRemove.length > 0) {
                    var updates = {};
                    itemsToRemove.forEach(function (item) {
                        updates[item.id] = 0;
                    });

                    window.adev_auto_upsell_config.finished = false;
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            updates: updates
                        })
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function () {
                        window.adev_auto_upsell_config.finished = true;
                        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                            bubbles: true
                        }));
                    })
                    .catch(function (error) {
                        window.adev_auto_upsell_config.finished = true;
                        console.error("Error updating cart:", error);
                    });
                } else {
                    window.adev_auto_upsell_config.finished = true;
                }

                // Add items if necessary
                if (itemsToAdd.length > 0) {
                    window.adev_auto_upsell_config.finished = false;
                    var formattedItems = itemsToAdd.map(function (item) {
                        return {
                            properties: {
                                __adev_upsell_gift: true
                            },
                            id: item.id,
                            quantity: item.quantity
                        };
                    });

                    var formData = new FormData();
                    adevCreateFormData(formData, "items", formattedItems);

                    fetch("/cart/add.js", {
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function () {
                        window.adev_auto_upsell_config.finished = true;
                        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                            bubbles: true
                        }));
                    })
                    .catch(function (error) {
                        window.adev_auto_upsell_config.finished = true;
                        console.error("Error adding items to cart:", error);
                    });
                } else {
                    window.adev_auto_upsell_config.finished = true;
                }
            })
            .catch(function (error) {
                window.adev_auto_upsell_config.finished = true;
                console.error("Error fetching cart:", error);
            });

    });

    document.dispatchEvent(new CustomEvent('adev:auto_upsell:init'));

    document.addEventListener("adev:cart:refreshed", function(){
        window.adev_auto_upsell_config.timeout = setTimeout(function () {
            if (window.adev_auto_upsell_config.finished === false) return;

            // console.log('refresh auto upsell');
            
            document.dispatchEvent(new CustomEvent('adev:auto_upsell:init'));
        }, 250);
    });

})());